import { TFunction } from "i18next";

import { warnAndToastException } from "../error.helpers";

export const safeDataLoad = async ({
  fn,
  t,
  fallbackKey,
}: {
  fn: () => Promise<void>;
  t: TFunction;
  fallbackKey: string;
}): Promise<void> => {
  try {
    await fn();
  } catch (error) {
    warnAndToastException({
      error,
      fallbackTranslationKey: fallbackKey,
      translationFunction: t,
    });
  }
};
